// Counting words, shared so every app reads one rule.

/** `"1 team"` / `"3 teams"`. Pass `many` when adding an `s` is wrong.
 *
 *  Returns the number WITH the word, because every caller wants both and the
 *  two versions of this that already existed disagreed about that: one
 *  returned the phrase, one returned only the word, which is exactly how a
 *  helper ends up written twice. */
export function plural(n: number, one: string, many = `${one}s`): string {
  return `${n} ${n === 1 ? one : many}`
}
